import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import PageContent from '../../components/Layout/PageContent';
import Video from '../../components/Video/Video';
import { FontSizes } from '../../core/config/mainTheme';
import { toCssValue } from '../../core/utils/theme.utils';
import ThemeBreadcrumbs from '../FinancialData/Company/BreadCrumbs';
import { BreadCrumbLink } from '../FinancialData/Company/BreadCrumbs/BreadCrumbs';
import HelpPageForm from './HelpPageForm';
import PhoneSupportCard from './PhoneSupportCard';

interface OwnProps {
  breadCrumbs: BreadCrumbLink[];
}

const VIDEO_SRC =
  'https://companies.royaltyrange.com/static/media/Company_financials_Video_RoyaltyRange.f8a5fc9a.mp4';

const UnauthenticatedHelpPage: React.FunctionComponent<OwnProps> = ({ breadCrumbs }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <div className={classes.breadcrumbContainer}>
        <ThemeBreadcrumbs items={breadCrumbs} />
      </div>
      <PageContent className={classes.contentContainer}>
        <Grid container justify="center" className={classes.rootContainer} spacing={4}>
          <Grid item xs={4}>
            <Card className={classes.bottomMargin}>
              <CardContent>
                <p className={classes.text}>
                  <Trans i18nKey="app:noAccessText" />
                </p>
                <p className={classes.formLabel}>
                  <Trans i18nKey="app:helpForm.formLabel" />
                </p>
                <HelpPageForm />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={2}>
            <Grid container alignItems="center" justify="center" direction="column" spacing={4}>
              <Grid item>
                <Video src={VIDEO_SRC} />
              </Grid>
              <Grid item>
                <PhoneSupportCard className={classes.cardBlock} />
              </Grid>
              <Grid item>
                <Card className={classes.cardBlock}>
                  <CardHeader title={t('app:help.supportEmailTitle')} />
                  <CardContent>
                    <Typography>
                      <a href={`mailto:${t('app:help.supportEmail')}`} target="_top">
                        {t('app:help.supportEmail')}
                      </a>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.box}>
          <Trans i18nKey="app:moreInfo" />
          <a href="https://www.royaltyrange.com/" target="_blank" rel="noopener noreferrer">
            https://www.royaltyrange.com/
          </a>
        </div>
      </PageContent>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  breadcrumbContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.dark,
    display: 'flex',
    flex: 1,
    padding: toCssValue([theme.spacing(0), theme.spacing(6)]),
    '& .MuiTypography-root': {
      fontSize: FontSizes.size.headerSize,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& .MuiButtonBase-root': {
      height: '44px',
      boxShadow: 'none',
    },
  },
  contentContainer: {
    flexDirection: 'column',
  },
  box: {
    display: 'flex',
    padding: theme.spacing(5),
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(5),
  },
  text: {
    marginTop: 0,
  },
  rootContainer: {
    padding: theme.spacing(5),
  },
  formLabel: {
    marginBottom: 0,
  },
  cardBlock: {
    minWidth: '300px',
    '& .MuiCardHeader-root': {
      color: theme.palette.primary.dark,
      paddingBottom: theme.spacing(4),
    },
    '& .MuiCardContent-root': {
      paddingTop: 0,
    },
  },
  video: {
    height: '100%',
    display: 'flex',
  },
}));

export default UnauthenticatedHelpPage;
